import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button, Image } from "react-bootstrap";
import "./index.css";
import { useNavigate } from "react-router-dom";
import on9estateLogo from "../../../assets/logo/on9estate-horizontal-logo.png";
const Header = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);
  const [shadow, setShadow] = useState(false);
  let lastScrollY = window.scrollY;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShow(false);
      } else {
        setShow(true);
      }

      setShadow(window.scrollY > 0);
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" className={`custom-navbar ${show ? "show" : "hide"} ${shadow ? "shadow-sm" : ""}`} fixed="top">
      <Container>
        <Navbar.Brand href="/">
          <Image src={on9estateLogo} height={35} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav shadow-none" style={{ boxShadow: 'none' }} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto text-center">
            <Nav.Link href="#about" className="nav-underline">About</Nav.Link>
            <Nav.Link href="#features" className="nav-underline">Features</Nav.Link>
            <Nav.Link href="#pricing" className="nav-underline">Pricing</Nav.Link>
            <Nav.Link href="#contact" className="nav-underline">Contact</Nav.Link>
            <div className="mobile-buttons d-lg-none mt-3">
              <Button variant="outline-primary" className="w-100 mb-3">Login</Button>
            </div>
          </Nav>
          <div className="d-none d-lg-block">
            <Button variant="primary" className="ms-3 py-2 btn-width" onClick={() => navigate("login")}>Login</Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;